import { useContext } from 'react';

import AppContext from './private/AppContext';

export default function useMarkAsDone() {
  return useContext(AppContext).markAsNotDone;
}
